import React from 'react';
import useGetQuestionsAndArticlesByCategory from '../../api/useGetQuestionsAndArticlesByCategory';
import { useQuery } from 'react-query';
import { Link, useParams } from 'react-router-dom';
import { createUrlFromQuestion } from '../knowledge/createUrlFromQuestion';
import TopicCloud from '../shared/TopicCloud';
import TopicDropDown from '../shared/TopicDropDown';
import DisplayQueryError from '../shared/DisplayQueryError';
import LoadingSpinner from '../shared/LoadingSpinner';
import DocumentHead from '../shared/DocumentHead';
import Header from '../shared/Header';
import { Container, Row, Col } from 'reactstrap';
import useTrackPageView from '../../hooks/useTrackPageView.ts';

const BrowseTopicPage: React.FC = () => {
    useTrackPageView();

    const { tagText } = useParams();

    const getQuestionsAndArticlesByCategory =
        useGetQuestionsAndArticlesByCategory({ tagText: tagText! });

    const {
        data: questionsAndArticlesByCategory,
        isLoading,
        error,
        refetch
    } = useQuery(
        ['questionsAndArticlesByCategory', tagText],
        getQuestionsAndArticlesByCategory
    );

    if (error) {
        return <DisplayQueryError error={error} refetch={refetch} />;
    }

    if (isLoading || !questionsAndArticlesByCategory) {
        return <LoadingSpinner />;
    }

    const { questions, articles } = questionsAndArticlesByCategory;

    return (
        <>
            <DocumentHead title={' - ' + tagText!} />
            <Header headerClassName='mini' />

            <section className='white-bg py-5'>
                <Container>
                    <Row>
                        <Col xs={12} className='mt-4'>
                            <div className='d-flex align-items-center'>
                                <h3 className='mb-0'>Topic:</h3>
                                <div className='custom-dropdown ms-3'>
                                    <TopicDropDown tagText={tagText!} />
                                </div>
                            </div>
                            <Row>
                                {questions?.length > 0 && (
                                    <Col md={6} className='mt-4 border-end'>
                                        <h4>Questions</h4>
                                        {questions.map((question) => (
                                            <div key={question.questionId}>
                                                <Link
                                                    target='_self'
                                                    to={createUrlFromQuestion(
                                                        question.questionId,
                                                        question.text
                                                    )}
                                                    className='question-link'
                                                >
                                                    {question.text}
                                                </Link>
                                            </div>
                                        ))}
                                    </Col>
                                )}
                                {articles?.length > 0 && (
                                    <Col md={6} className='mt-4'>
                                        <h4>Articles</h4>
                                        {articles.map((article) => (
                                            <div key={article.slug}>
                                                <Link
                                                    target='_self'
                                                    to={`/article/${article.slug}`}
                                                    className='question-link'
                                                >
                                                    {article.title}
                                                </Link>
                                            </div>
                                        ))}
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <TopicCloud />
                </Container>
            </section>
        </>
    );
};

export default BrowseTopicPage;
